var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "b-col",
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-lg": "right"
              }
            },
            [
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER
                ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                    _vm._v(_vm._s(_vm.$t("Asumismuoto")))
                  ])
                : _c("label", { staticClass: "font-weight-bold pt-0" }, [
                    _vm._v(_vm._s(_vm.$t("Toimiala")))
                  ]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.housingTypeString(_vm.contract.HousingTypeId)) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-lg": "right"
              }
            },
            [
              _c("label", { staticClass: "font-weight-bold pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Lämmitystapa")))
              ]),
              _vm._v(
                " " + _vm._s(_vm.heatingTypeString(_vm.contract.HeatingTypeId))
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-lg": "right"
              }
            },
            [
              _c("label", { staticClass: "font-weight-bold pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Mittaustapa")))
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.tarificationTypeString(_vm.contract.TarificationId)
                  ) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-lg": "right"
              }
            },
            [
              _c("label", { staticClass: "font-weight-bold pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Pinta-ala")))
              ]),
              _vm._v(" " + _vm._s(_vm.houseAreaString()) + " m²")
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-lg": "right"
              }
            },
            [
              _c("label", { staticClass: "font-weight-bold pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Vuosikulutus")))
              ]),
              _vm._v(
                " " +
                  _vm._s(_vm.contract.Energy1) +
                  _vm._s(
                    _vm.showEnergy2Consumption
                      ? " / " + _vm.contract.Energy2
                      : ""
                  ) +
                  " kWh "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }